var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftdisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.675449 6.29978C0.441517 6.06585 0.441517 5.68757 0.675449 5.45613L5.45365 0.675448C5.68758 0.441516 6.06585 0.441516 6.2973 0.675448C6.52874 0.909381 6.53123 1.28765 6.2973 1.5191L1.94217 5.87422L6.29979 10.2318C6.53372 10.4658 6.53372 10.844 6.29979 11.0755C6.06585 11.3069 5.68758 11.3094 5.45614 11.0755L0.675449 6.29978Z",
    stroke: "#C5BFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftdisabled);
export default __webpack_public_path__ + "static/media/leftdisabled.3deb4bbf1219be92b7f857c85dafac9c.svg";
export { ForwardRef as ReactComponent };